// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Text } from "@blueprintjs/core";
import { Classes } from "src/mpd-library";

import { Tab, TabId, Tabs } from "@blueprintjs/core";

import "./styles.css";

export interface ISeverity extends HTMLDivProps {
  severity: any;
  tabs: Array<string>;
  onTabChanged(newTabId: TabId, prevTabId: TabId, event: any): void;
}

export const Severity: React.SFC<ISeverity> = props => {
  const { className, severity, tabs, onTabChanged } = props;
  const classes = classNames(
    myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER,
    className
  );

  return (
    <div className={classes}>
      <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
        SEVERITY
      </Text>
      <Tabs
        className={classNames(
          myClasses.ALERTS_CONTENT_COMPOSE_TABS_CONTAINER,
          Classes.severitiesClass(severity.type)
        )}
        defaultSelectedTabId={0}
        selectedTabId={severity.id}
        id={myClasses.ALERTS_CONTENT_COMPOSE_TABS}
        onChange={onTabChanged}
      >
        {tabs.map((title: any, index: number) => (
          <Tab
            className={classNames(
              Classes.severitiesClass(severity.type),
              ((severity.id) + 1) === index && 'next-tab',
              ((severity.id) - 1) === index && 'previous-tab'
            )}
            id={index}
            key={index}
            title={title}
          />
        ))}
      </Tabs>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/alert-details/severity.tsx